<template>
  <b-dropdown
    variant="link"
    toggle-class="sf-nav-icon-btn p-0"
    menu-class="sf-nav-menu sf-notif-menu"
    no-caret
    right
    @show="marcarLidos"
  >
    <template #button-content>
      <feather-icon
        icon="BellIcon"
        size="15"
      />
      <span
        v-if="data.naoLida > 0"
        class="sf-nav-notif-badge"
      />
    </template>

    <div class="sf-notif-head">
      <span class="sf-notif-title">{{ $t('Notificações') }}</span>
      <span class="sf-notif-count">{{ data.naoLida || 0 }} {{ $t('Novas') }}</span>
    </div>

    <div
      v-if="data.notificacoes && data.notificacoes.length"
      class="sf-notif-list"
    >
      <router-link
        v-for="(n, i) in data.notificacoes"
        :key="i"
        :to="{ name: 'notificacao' }"
        class="sf-notif-item"
      >
        <span
          class="sf-notif-icon"
          :class="'is-' + (n.estilo || 'info')"
        >
          <feather-icon
            :icon="getIconNotificacao(n.estilo)"
            size="15"
          />
        </span>
        <span class="sf-notif-body">
          <span class="sf-notif-item-title">
            {{ n.titulo }}
            <small>{{ elapsedTime(n.dataCriacao) }}</small>
          </span>
          <span class="sf-notif-msg">{{ n.mensagem }}</span>
        </span>
      </router-link>
    </div>
    <div
      v-else
      class="sf-notif-empty"
    >
      {{ $t('nenhumaNotificacao') }}
    </div>

    <router-link
      v-if="data.notificacoes && data.notificacoes.length"
      :to="{ name: 'notificacao' }"
      class="sf-notif-footer"
    >
      {{ $t('lerTodasNotificacoesBtn') }}
    </router-link>
  </b-dropdown>
</template>

<script>
// Sino de notificações no navbar (redesign Soulf): botão 36x36 que abre um
// dropdown com as últimas (como antes). Reaproveita o mesmo store do sino antigo.
import { BDropdown } from 'bootstrap-vue'
import utilsMixin from '@/mixins/utilsMixin'

export default {
  name: 'NavbarNotifications',
  components: { BDropdown },
  mixins: [utilsMixin],

  data() {
    return {
      data: { notificacoes: [], naoLida: 0 },
      polling: null,
    }
  },

  created() {
    this.getNotificacoes()
    this.polling = setInterval(this.getNotificacoes, 5000)
  },

  beforeDestroy() {
    if (this.polling) clearInterval(this.polling)
  },

  methods: {
    getNotificacoes() {
      this.$store.dispatch('notificacao/getNotificacoesSino')
        .then(response => { this.data = response.data })
        .catch(() => {})
    },
    marcarLidos() {
      this.$store.dispatch('notificacao/setLidos').catch(() => {})
      this.$set(this.data, 'naoLida', 0)
    },
    getIconNotificacao(estilo) {
      if (estilo === 'success') return 'CheckIcon'
      if (estilo === 'danger') return 'XIcon'
      if (estilo === 'warning') return 'AlertTriangleIcon'
      return 'MessageCircleIcon'
    },
  },
}
</script>

<style lang="scss" scoped>
.sf-notif-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.10);
  margin-bottom: 4px;

  .sf-notif-title { font-weight: 600; font-size: 13px; color: #fff; }
  .sf-notif-count {
    font-size: 11px;
    color: #3b82f6;
    background: rgba(59, 130, 246, 0.12);
    border-radius: 6px;
    padding: 2px 8px;
  }
}

.sf-notif-list {
  max-height: 320px;
  overflow-y: auto;
}

.sf-notif-item {
  display: flex;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 8px;
  text-decoration: none;

  &:hover { background: rgba(255, 255, 255, 0.06); text-decoration: none; }

  .sf-notif-icon {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8b8f98;
    background: #1C1C1E;

    &.is-success { color: #4ade80; background: rgba(34, 197, 94, 0.12); }
    &.is-danger { color: #f87171; background: rgba(239, 68, 68, 0.12); }
    &.is-warning { color: #F0B90B; background: rgba(240, 185, 11, 0.14); }
    &.is-info { color: #3b82f6; background: rgba(59, 130, 246, 0.12); }
  }

  .sf-notif-body { min-width: 0; display: flex; flex-direction: column; gap: 2px; }
  .sf-notif-item-title {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
    color: #fff;
    small { color: rgba(255, 255, 255, 0.35); font-size: 11px; white-space: nowrap; }
  }
  .sf-notif-msg {
    font-size: 12px;
    color: #8b8f98;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.sf-notif-empty {
  padding: 20px 10px;
  text-align: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
}

.sf-notif-footer {
  display: block;
  margin: 6px 4px 2px;
  padding: 9px;
  text-align: center;
  border-radius: 8px;
  background: #3b82f6;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;

  &:hover { background: #2f6fd6; color: #fff; text-decoration: none; }
}
</style>
